import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTournamentResults } from '../api/hooks';
import { Loader, ErrorView, EmptyView } from '../components/StateViews';
import { BackIcon } from '../components/icons';
import { backButton } from '../telegram';
import { shortDate } from '../format';

/** "Результат турнира" — final standings + rating points. */
export function TournamentResultScreen() {
  const { id } = useParams();
  const tid = Number(id);
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useTournamentResults(tid);

  useEffect(() => {
    const back = () => navigate(-1);
    backButton.show(back);
    return () => backButton.hide(back);
  }, [navigate]);

  if (isLoading) return <Loader />;
  if (isError || !data) return <ErrorView message={(error as Error)?.message} />;

  const { game, rows } = data;
  if (rows.length === 0) return <EmptyView message="Нет результатов по этому турниру" />;

  const me = rows.find((r) => r.isMe);

  return (
    <div>
      <div data-theme="dark" className="detail-hero">
        <div className="hero-top">
          <button className="iconbtn" onClick={() => navigate(-1)} aria-label="Назад">
            <BackIcon />
          </button>
        </div>
        <div className="hero-title" style={{ fontSize: 20 }}>
          {game.title ?? game.format ?? 'Турнир'}
        </div>
        <div className="hero-meta">
          {shortDate(game.startTime)}
          {game.format ? ` · ${game.format}` : ''} · {game.fieldSize} игроков
        </div>
      </div>

      {me && (
        <div className="result-summary">
          <div className="place">
            <span className="num">{me.position ?? '—'}</span>
            <span className="lbl">место</span>
          </div>
          <div className="vdiv" />
          <div className="cell">
            <div className="v green">{me.points > 0 ? `+${me.points}` : '—'}</div>
            <div className="l">очков</div>
          </div>
          <div className="cell">
            <div className="v">{game.fieldSize}</div>
            <div className="l">игроков</div>
          </div>
        </div>
      )}

      <div className="lb-head">
        <span>Место · Игрок</span>
        <span>Очки рейтинга</span>
      </div>
      <div className="card" style={{ padding: '4px 6px' }}>
        {rows.map((r) => (
          <Link className={`lb-row ${r.isMe ? 'me' : ''}`} key={r.playerId} to={`/players/${r.playerId}`}>
            <div className="lb-rank">{r.position ?? '—'}</div>
            <div className="lb-name">
              {r.name}
              {r.position === 1 ? ' ♛' : ''}
            </div>
            <div className="lb-points">{r.points > 0 ? `+${r.points}` : '—'}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
